import React from 'react';

function UnitedKingdom(props) {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V24H36V0H0Z"
        fill="#2E42A5"
      />
      <mask
        id="mask0_1529_5905"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H36V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1529_5905)">
        <mask
          id="mask1_1529_5905"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask1_1529_5905)">
          <path
            d="M-4.00854 22.2854L3.91336 25.2635L36.1797 3.23787L40.3584 -1.18761L31.887 -2.18297L18.7263 7.3085L8.13334 13.7035L-4.00854 22.2854Z"
            fill="white"
          />
          <path
            d="M-2.92407 24.3719L1.11177 26.1001L38.8578 -1.59881H33.191L-2.92407 24.3719Z"
            fill="#F50100"
          />
          <path
            d="M40.0085 22.2854L32.0866 25.2635L-0.179749 3.23787L-4.35837 -1.18761L4.11296 -2.18297L17.2737 7.3085L27.8667 13.7035L40.0085 22.2854Z"
            fill="white"
          />
          <path
            d="M39.7383 23.7829L35.7024 25.5111L19.6298 13.6518L14.8646 12.3267L-4.7604 -1.17246H0.906387L20.5204 12.0063L25.7303 13.5952L39.7383 23.7829Z"
            fill="#F50100"
          />
          <mask id="path-8-inside-1_1529_5905" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.2501 -2H13.7501V8H-2.21899V16H13.7501V26H22.2501V16H38.281V8H22.2501V-2Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.2501 -2H13.7501V8H-2.21899V16H13.7501V26H22.2501V16H38.281V8H22.2501V-2Z"
            fill="#F50100"
          />
          <path
            d="M13.7501 -2V-4H11.7501V-2H13.7501ZM22.2501 -2H24.2501V-4H22.2501V-2ZM13.7501 8V10H15.7501V8H13.7501ZM-2.21899 8V6H-4.21899V8H-2.21899ZM-2.21899 16H-4.21899V18H-2.21899V16ZM13.7501 16H15.7501V14H13.7501V16ZM13.7501 26H11.7501V28H13.7501V26ZM22.2501 26V28H24.2501V26H22.2501ZM22.2501 16V14H20.2501V16H22.2501ZM38.281 16V18H40.281V16H38.281ZM38.281 8H40.281V6H38.281V8ZM22.2501 8H20.2501V10H22.2501V8ZM13.7501 0H22.2501V-4H13.7501V0ZM15.7501 8V-2H11.7501V8H15.7501ZM-2.21899 10H13.7501V6H-2.21899V10ZM-0.218994 16V8H-4.21899V16H-0.218994ZM13.7501 14H-2.21899V18H13.7501V14ZM15.7501 26V16H11.7501V26H15.7501ZM22.2501 24H13.7501V28H22.2501V24ZM20.2501 16V26H24.2501V16H20.2501ZM38.281 14H22.2501V18H38.281V14ZM36.281 8V16H40.281V8H36.281ZM22.2501 10H38.281V6H22.2501V10ZM20.2501 -2V8H24.2501V-2H20.2501Z"
            fill="white"
            mask="url(#path-8-inside-1_1529_5905)"
          />
        </g>
      </g>
    </svg>
  );
}

export default UnitedKingdom;
